module.exports = __webpack_public_path__ + "img/empty_field.9602978d.svg";